import React from 'react'
import { css, cx } from '@emotion/css'
import { SortOrder } from '.'
import { theme } from '@contrast-security-inc/design-system-foundations'

export function LegacyGridSortAction({
  onSortAscending,
  onSortDescending,
  activeSortOrder
}: {
  readonly onSortAscending: () => void
  readonly onSortDescending: () => void
  readonly activeSortOrder?: SortOrder
}) {
  const legacyIconBaseCss = css`
    font-family: 'contrast';
    speak: none;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  `
  const iconCss = css`
    font-size: 26px;
    display: block;
    color: ${theme.color.neutral40};
    &:hover {
      color: ${theme.color.neutral70};
      cursor: pointer;
    }
    height: 37px;
    line-height: 14px;
  `
  const activeCss = css`
    color: ${theme.color.turquoise70};
  `
  return (
    <div
      className={css`
        display: flex;
        flex-direction: column;
        height: 31px;
      `}
    >
      <div
        data-testid="legacy-grid-sort-action-asc"
        className={cx(
          legacyIconBaseCss,
          'contricon-keyboard_arrow_up',
          iconCss,
          css`
            transform: translateY(3px);
          `,
          !!activeSortOrder && activeSortOrder === SortOrder.ASC && activeCss
        )}
        onClick={onSortAscending}
      />
      <div
        data-testid="legacy-grid-sort-action-desc"
        className={cx(
          legacyIconBaseCss,
          'contricon-keyboard_arrow_down',
          iconCss,
          css`
            transform: translateY(0px);
          `,
          !!activeSortOrder && activeSortOrder === SortOrder.DESC && activeCss
        )}
        onClick={onSortDescending}
      />
    </div>
  )
}
